import request from '@/utils/request'

// 分页查询银河打本店铺人员审核
export function pageUserShopAudit(query) {
  return request({
    url: '/user/played/shop/audit/pageUserShopAudit',
    method: 'get',
    params: query
  })
}

// 管理后台加入申请审核
export function adminAuditJoinApply(data) {
  return request({
    url: '/user/played/shop/audit/adminAuditJoinApply',
    method: 'put',
    data: data
  })
}
